import { gql } from '@apollo/client';
import { ProjectItem } from '../fragments/project';

export const PROJECT_NEARBY_QUERY = gql`
  query ($id: [Int], $locationDistrictId: [Int]) {
    otherNearbyProjectData: projects(
      request: {
        exclude: $id
        custom: { locationDistrictId: $locationDistrictId }
      }
    ) {
      items {
        id
        title
        propertyType
        date
        modified
        link
        tags {
          id
          name
          link
        }
        propertyType
        featuredImage {
          url
          title
          width
          height
        }
        totalComments
        developer {
          name
          website
          website_label
          phone
        }
        location {
          zone {
            label
            value
            link
            parent {
              value
              label
              link
            }
          }
          district {
            label
            value
            link
            parent {
              value
              label
              link
            }
          }
          road {
            label
            value
            link
            parent {
              value
              label
              link
            }
          }
        }
        transportations {
          value
          label
          link
        }
        priceTypes {
          starting_price
          level {
            value
            label
          }
        }
        logo {
          image {
            url
          }
          background_color
        }
      }
    }
  }
`;
export interface ProjectNearbyQueryRequest {
  id: number;
  locationDistrictId: number;
}

export interface ProjectNearbyQueryResponse {
  otherNearbyProjectData?: {
    items: ProjectItem[];
  };
}
